module.exports = __webpack_public_path__ + "img/level_three.c4e291b1.png";